import { noop } from 'lodash';


export function beep({
  duration = 500,
  frequency = 400,
  volume = 1,
  type = 'sine',
  callback = noop,
}: {
  duration?: number,
  frequency?: number,
  volume?: number,
  type?: OscillatorNode['type'],
  callback?: () => void,
}): void {
  const audioCtx = new AudioContext();
  const oscillator = audioCtx.createOscillator();
  const gainNode = audioCtx.createGain();

  oscillator.connect(gainNode);
  gainNode.connect(audioCtx.destination);

  if (volume) {
    gainNode.gain.value = volume;
  }
  if (frequency) {
    oscillator.frequency.value = frequency;
  }
  if (type) {
    oscillator.type = type;
  }
  if (callback) {
    oscillator.onended = callback;
  }

  oscillator.start(audioCtx.currentTime);
  oscillator.stop(audioCtx.currentTime + (duration || 500) / 1000);
};

export default beep;